export enum POKEMON_TYPES {
  NORMAL = 'NORMAL',
  FIRE = 'FIRE',
  WATER = 'WATER',
  ELECTRIC = 'ELECTRIC',
  GRASS = 'GRASS',
  ICE = 'ICE',
  FIGHTING = 'FIGHTING',
  POISON = 'POISON',
  GROUND = 'GROUND',
  FLYING = 'FLYING',
  PSYCHIC = 'PSYCHIC',
  BUG = 'BUG',
  ROCK = 'ROCK',
  GHOST = 'GHOST',
  DRAGON = 'DRAGON',
  DARK = 'DARK',
  STEEL = 'STEEL',
  FAIRY = 'FAIRY',
  SHADOW = 'SHADOW',
  UNKNOWN = 'UNKNOWN',
}

export enum TYPE_COLORS {
  NORMAL = '#A8A77A',
  FIRE = '#EE8130',
  WATER = '#6390F0',
  ELECTRIC = '#F7D02C',
  GRASS = '#7AC74C',
  ICE = '#96D9D6',
  FIGHTING = '#C22E28',
  POISON = '#A33EA1',
  GROUND = '#E2BF65',
  FLYING = '#A98FF3',
  PSYCHIC = '#F95587',
  BUG = '#A6B91A',
  ROCK = '#B6A136',
  GHOST = '#735797',
  DRAGON = '#6F35FC',
  DARK = '#705746',
  STEEL = '#B7B7CE',
  FAIRY = '#D685AD',
  SHADOW = '#604E82',
  UNKNOWN = '#68A090',
}

export enum POKEMON_STATS {
  HP = 'HP',
  ATTACK = 'Atk',
  DEFENSE = 'Def',
  SPECIAL_ATTACK = 'SpAtk',
  SPECIAL_DEFENSE = 'SpDef',
  SPEED = 'Speed',
}

export enum SIZES {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum DIRECTIONS {
  NEXT = 'Next',
  PREVIOUS = 'Previous',
}

export enum GRID_PAGES {
  A = 'gridSlideA',
  B = 'gridSlideB',
  C = 'gridSlideC',
}
